
const returnFirstIfArray = (value: any) => Array.isArray(value)
  ? value[0]
  : value

export {
  returnFirstIfArray,
}